import React from 'react';
import {Link} from "react-router-dom";

interface UserErrorProps {
    message?: string | null;
}

export default  function UserError({message}: UserErrorProps) {

	if (!message) {
		return null;
	}

	return (
		<><br />
			<div className="alert alert-warning alert-dismissible fade show" role="alert">
				<div dangerouslySetInnerHTML={{__html: message}}/>
				<button type="button" className="close" data-dismiss="alert" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			</>
		)
}